<div style="text-align: center">
  <h3><b>Time-Dependent Values</b></h3>
</div>
<wj-flex-sheet #flex (initialized)="initializeFlexSheet(flex)"> </wj-flex-sheet>
